import { hubService } from '@/services';
export default {
    setStoreSettingDialogOpen({ commit }, isOpen = true) {
        commit('SET_STORE_SETTING_DIALOG_OPEN', isOpen);
    },
    setSelectedSettingGroup({ commit }, group) {
        commit('SET_SELECTED_SETTING_GROUP', group);
    },
    setFilterOption({ commit }, payload) {
        commit('SET_FILTER_OPTION', payload);
    },
    setWorkerFeePerStoreGroupRegisterList({ state, commit }, register) {
        const isOriginHasRegister = state.workerFeePerStoreGroupStoreList
            .some((store) => store.code === register.code);
        const unregisterList = state.unregisterList
            .filter((unregister) => unregister !== register);
        commit('SET_WORKER_FEE_PER_STORE_GROUP_UNREGISTER_LIST', unregisterList);
        if (isOriginHasRegister) {
            commit('SET_WORKER_FEE_PER_STORE_GROUP_REGISTER_LIST', state.registerList);
            return;
        }
        const registerList = state.registerList.concat(register);
        commit('SET_WORKER_FEE_PER_STORE_GROUP_REGISTER_LIST', registerList);
    },
    setWorkerFeePerStoreGroupUnregisterList({ state, commit }, unregister) {
        const isOriginHasUnregister = state.workerFeePerStoreGroupAvailableStoreList
            .some((store) => store.code === unregister.code);
        const registerList = state.registerList
            .filter((register) => register !== unregister);
        commit('SET_WORKER_FEE_PER_STORE_GROUP_REGISTER_LIST', registerList);
        if (isOriginHasUnregister) {
            commit('SET_WORKER_FEE_PER_STORE_GROUP_UNREGISTER_LIST', state.unregisterList);
            return;
        }
        const unregisterList = state.unregisterList.concat(unregister);
        commit('SET_WORKER_FEE_PER_STORE_GROUP_UNREGISTER_LIST', unregisterList);
    },
    /**
     * 상점 관리 상점 설정 상점 등록/삭제
     * @param payload
     * @param payload.groupId 상점을 추가 혹은 삭제할 그룹.
     * @param [payload.registers] 추가할 상점 목록.
     * @param [payload.unregisters] 삭제할 상점 목록.
     */
    async putWorkerFeePerStoreGroupRegister({ commit, rootGetters }, payload) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '' } = payload;
        const response = await hubService.putWorkerFeePerStoreGroupStoreList({
            hubId,
            groupId,
            payload,
        });
        commit('PUT_WORKER_FEE_PER_STORE_GROUP_REGISTER', response.isSuccess);
    },
    /**
     * 상점 관리 수수료 그룹 상점 목록 조회
     * @param payload
     * @param payload.groupId 상점을 추가 혹은 삭제할 그룹.
     */
    async getWorkerFeePerStoreGroupStoreList({ commit, rootGetters }, payload) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', type = 'HUB' } = payload;
        const response = await hubService.getWorkerFeePerStoreGroupStoreList({
            hubId,
            groupId,
            type,
        });
        commit('GET_WORKER_FEE_PER_STORE_GROUP_STORE_LIST', response.data);
    },
    /**
     * 상점 관리 수수료 그룹 등록 가능한 상점 목록 조회
     * @param payload
     * @param payload.groupId 상점을 추가 혹은 삭제할 그룹.
     */
    async getWorkerFeePerStoreGroupAvailableStoreList({ commit, rootGetters }, payload) {
        const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
        const { groupId = '', type = 'HUB' } = payload;
        const response = await hubService.getWorkerFeePerStoreGroupAvailableStoreList({
            hubId,
            groupId,
            type,
        });
        commit('GET_WORKER_FEE_PER_STORE_GROUP_AVAILABLE_STORE_LIST', response.data);
    },
    clearDialogInfo({ commit }) {
        commit('CLEAR_SELECTED_SETTING_GROUP');
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_STORE_LIST');
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_AVAILABLE_STORE_LIST');
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_REGISTER_LIST');
    },
    clearSelectedSettingGroup({ commit }) {
        commit('CLEAR_SELECTED_SETTING_GROUP');
    },
    clearWorkerFeePerStoreGroupStoreList({ commit }) {
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_STORE_LIST');
    },
    clearWorkerFeePerStoreGroupAvailableStoreList({ commit }) {
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_AVAILABLE_STORE_LIST');
    },
    clearWorkerFeePerStoreGroupRegisterList({ commit }) {
        commit('CLEAR_WORKER_FEE_PER_STORE_GROUP_REGISTER_LIST');
    },
};
